module.exports = __webpack_public_path__ + "fonts/WorkSans-Bold.a0bf66dd.ttf";